
// import { useState, useEffect } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { toast } from 'react-hot-toast';
// import axios from 'axios';

// // Use Vite env (not process.env)
// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3008';

// export default function VideoManager() {
//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [editMode, setEditMode] = useState(false);

//   // Upload state
//   const [files, setFiles] = useState([]);
//   const [uploadForm, setUploadForm] = useState({
//     external_entity_id: '',
//     title: '',
//     description: '',
//     visibility: 'public',
//     tags: '',
//   });

//   // Edit form
//   const [editForm, setEditForm] = useState({});

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     accept: { 'video/*': ['.mp4', '.mov', '.avi', '.webm', '.mkv'] },
//     maxSize: 500 * 1024 * 1024,
//     multiple: true,
//     onDrop: (accepted) => {
//       setFiles(accepted.map(f => Object.assign(f, { preview: URL.createObjectURL(f) })));
//     },
//   });

//   // Load videos
//   const loadVideos = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_URL}/api/videos`);
//       setVideos(res.data.data || []);
//     } catch (err) {
//       toast.error('Failed to load videos');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadVideos();
//   }, []);

//   // Upload
//   const handleUpload = async (e) => {
//     e.preventDefault();
//     if (!files.length) return toast.error('Select at least one video');
//     if (!uploadForm.external_entity_id) return toast.error('Job ID required');

//     setUploading(true);
//     const formData = new FormData();

//     // CORRECT: Use 'videos' field name
//     files.forEach(file => formData.append('videos', file));

//     // Add metadata
//     formData.append('external_entity_type', 'job');
//     formData.append('external_entity_id', uploadForm.external_entity_id);
//     if (uploadForm.title) formData.append('title', uploadForm.title);
//     if (uploadForm.description) formData.append('description', uploadForm.description);
//     if (uploadForm.visibility) formData.append('visibility', uploadForm.visibility);
//     if (uploadForm.tags) {
//       uploadForm.tags.split(',').map(t => t.trim()).filter(t => t).forEach(t => formData.append('tags[]', t));
//     }

//     try {
//       await axios.post(`${API_URL}/api/videos/upload`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       toast.success('Uploaded! Processing...');
//       setFiles([]);
//       setUploadForm({ ...uploadForm, title: '', description: '', tags: '' });
//       loadVideos();
//     } catch (err) {
//       console.error('Upload error:', err.response?.data || err);
//       toast.error(err.response?.data?.message || 'Upload failed');
//     } finally {
//       setUploading(false);
//     }
//   };

//   // Update
//   const handleUpdate = async () => {
//     try {
//       const updates = {
//         title: editForm.title,
//         description: editForm.description,
//         visibility: editForm.visibility,
//       };
//       await axios.put(`${API_URL}/api/videos/${selectedVideo.id}`, updates);
//       toast.success('Updated!');
//       setEditMode(false);
//       loadVideos();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Update failed');
//     }
//   };

//   // Delete
//   const handleDelete = async (id) => {
//     if (!confirm('Delete this video?')) return;
//     try {
//       await axios.delete(`${API_URL}/api/videos/${id}`);
//       toast.success('Deleted');
//       loadVideos();
//     } catch (err) {
//       toast.error('Delete failed');
//     }
//   };

//   // Record View
//   const recordView = async (id) => {
//     try {
//       await axios.post(`${API_URL}/api/videos/${id}/view`, {
//         user_identifier: 'user_123',
//       });
//     } catch (err) {
//       console.error('View record failed', err);
//     }
//   };

//   return (
//     <div className="max-w-7xl mx-auto p-6 space-y-12">
//       {/* Upload Section */}
//       <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
//         <h2 className="text-3xl font-bold text-gray-800 mb-8">Upload Job Videos</h2>
//         <form onSubmit={handleUpload} className="space-y-6">
//           {/* Dropzone */}
//           <div
//             {...getRootProps()}
//             className={`border-4 border-dashed rounded-xl p-10 text-center cursor-pointer transition-all
//               ${isDragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-gray-50'}
//               ${files.length > 0 ? 'mb-6' : 'mb-8'}`}
//           >
//             <input {...getInputProps()} />
//             <div className="flex flex-col items-center">
//               <svg className="w-16 h-16 text-blue-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
//               </svg>
//               <p className="text-lg font-semibold text-gray-700">
//                 {isDragActive ? 'Drop videos here' : 'Drag & drop videos here'}
//               </p>
//               <p className="text-sm text-gray-500 mt-1">or click to select (Max 500MB)</p>
//             </div>
//           </div>

//           {/* Preview */}
//           {files.length > 0 && (
//             <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
//               {files.map((file, i) => (
//                 <div key={i} className="relative group rounded-lg overflow-hidden shadow">
//                   <video
//                     src={file.preview}
//                     controls
//                     className="w-full h-32 object-cover"
//                   />
//                   <button
//                     onClick={() => setFiles(files.filter((_, idx) => idx !== i))}
//                     className="absolute top-2 right-2 bg-red-600 text-white p-1.5 rounded-full opacity-0 group-hover:opacity-100 transition"
//                   >
//                     <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                     </svg>
//                   </button>
//                   <p className="text-xs text-gray-600 mt-1 truncate px-1">{file.name}</p>
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Form Fields */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//             <input
//               required
//               type="text"
//               placeholder="Job ID (external_entity_id) *"
//               value={uploadForm.external_entity_id}
//               onChange={e => setUploadForm({ ...uploadForm, external_entity_id: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
//             />
//             <input
//               type="text"
//               placeholder="Video Title"
//               value={uploadForm.title}
//               onChange={e => setUploadForm({ ...uploadForm, title: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           <textarea
//             placeholder="Description (optional)"
//             value={uploadForm.description}
//             onChange={e => setUploadForm({ ...uploadForm, description: e.target.value })}
//             rows={3}
//             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 resize-none"
//           />

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//             <select
//               value={uploadForm.visibility}
//               onChange={e => setUploadForm({ ...uploadForm, visibility: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="public">Public</option>
//               <option value="private">Private</option>
//               <option value="unlisted">Unlisted</option>
//             </select>
//             <input
//               type="text"
//               placeholder="Tags (comma separated)"
//               value={uploadForm.tags}
//               onChange={e => setUploadForm({ ...uploadForm, tags: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={uploading || files.length === 0}
//             className={`w-full py-4 rounded-lg font-bold text-white transition-all transform
//               ${uploading || files.length === 0
//                 ? 'bg-gray-400 cursor-not-allowed'
//                 : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 hover:scale-105 shadow-lg'
//               }`}
//           >
//             {uploading ? (
//               <span className="flex items-center justify-center gap-2">
//                 <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
//                 </svg>
//                 Uploading...
//               </span>
//             ) : (
//               `Upload ${files.length} Video${files.length > 1 ? 's' : ''}`
//             )}
//           </button>
//         </form>
//       </div>

//       {/* Video List */}
//       <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
//         <h2 className="text-3xl font-bold text-gray-800 mb-8">Your Uploaded Videos</h2>
//         {loading ? (
//           <p className="text-center text-gray-500">Loading videos...</p>
//         ) : videos.length === 0 ? (
//           <p className="text-center text-gray-500">No videos uploaded yet.</p>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {videos.map(video => (
//               <div key={video.id} className="group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border">
//                 <div className="relative h-48 bg-black">
//                   <video
//                     src={video.video_url}
//                     poster={video.thumbnail_url}
//                     controls
//                     className="w-full h-full object-cover"
//                     onPlay={() => recordView(video.id)}
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
//                 </div>
//                 <div className="p-5">
//                   <h3 className="font-bold text-lg text-gray-800 line-clamp-1">{video.title || 'Untitled'}</h3>
//                   <p className="text-sm text-gray-600 mt-1">Job ID: <span className="font-mono">{video.external_entity_id}</span></p>
//                   <div className="flex items-center gap-3 text-xs text-gray-500 mt-2">
//                     <span>Views: {video.view_count || 0}</span>
//                     <span>•</span>
//                     <span className={`px-2 py-1 rounded-full text-xs font-medium
//                       ${video.visibility === 'public' ? 'bg-green-100 text-green-700' :
//                         video.visibility === 'private' ? 'bg-red-100 text-red-700' :
//                         'bg-yellow-100 text-yellow-700'}`}>
//                       {video.visibility}
//                     </span>
//                   </div>
//                   <div className="flex gap-2 mt-4">
//                     <button
//                       onClick={() => {
//                         setSelectedVideo(video);
//                         setEditForm({
//                           title: video.title || '',
//                           description: video.description || '',
//                           visibility: video.visibility || 'public',
//                         });
//                         setEditMode(true);
//                       }}
//                       className="flex-1 bg-blue-600 text-white py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(video.id)}
//                       className="flex-1 bg-red-600 text-white py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition"
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Edit Modal */}
//       {editMode && (
//         <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
         
//             <h3 className="text-2xl font-bold text-gray-800 mb-5">Edit Video</h3>
//             <input
//               type="text"
//               placeholder="Title"
//               value={editForm.title || ''}
//               onChange={e => setEditForm({ ...editForm, title: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
//             />
//             <textarea
//               placeholder="Description"
//               value={editForm.description || ''}
//               onChange={e => setEditForm({ ...editForm, description: e.target.value })}
//               rows={3}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500 resize-none"
//             />
//             <select
//               value={editForm.visibility || 'public'}
//               onChange={e => setEditForm({ ...editForm, visibility: e.target.value })}
//               className="w-full px-4 py-3 border border-gray-300 rounded-lg mb-5 focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="public">Public</option>
//               <option value="private">Private</option>
//               <option value="unlisted">Unlisted</option>
//             </select>
//             <div className="flex gap-3">
//               <button
//                 onClick={handleUpdate}
//                 className="flex-1 bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition"
//               >
//                 Save Changes
//               </button>
//               <button
//                 onClick={() => setEditMode(false)}
//                 className="flex-1 bg-gray-600 text-white py-3 rounded-lg font-bold hover:bg-gray-700 transition"
//               >
//                 Cancel
//               </button>
//             </div>
     
//         </div>
//       )}
//     </div>
//   );
// }

























import React, { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import CloudinaryUpload from '../CloudinaryUpload';

const PostVideoForm = () => {
  const [description, setDescription] = useState('');
  const [videoUrl, setVideoUrl] = useState('');        // ← Cloudinary URL
  const [cloudinaryUploading, setCloudinaryUploading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const handleUploadStart = () => {
    setCloudinaryUploading(true);
    setVideoUrl(''); // clear previous url when new upload starts
  };

  const handleUploadComplete = (url, publicId) => {
    console.log('Cloudinary upload finished → URL:', url);
    setVideoUrl(url);
    setCloudinaryUploading(false);
    toast.success('Video uploaded to Cloudinary');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!videoUrl) {
      toast.error('No video URL available. Please upload a video.');
      return;
    }

    if (!description.trim()) {
      toast.error('Please add a description');
      return;
    }

    setSubmitting(true);

    try {
      const token = localStorage.getItem( 'token');
console.log(token)
      await axios.post(
        `${API_URL}videos`,
        {
          videoUrl,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success('Video posted successfully!');

      // Reset form
      setDescription('');
      setVideoUrl('');
    } catch (err) {
      console.error('Backend submit error:', err);
      toast.error(err.response?.data?.message || 'Failed to post video');
    } finally {
      setSubmitting(false);
    }
  };

  // Button should be disabled only when:
  // - uploading to Cloudinary OR
  // - submitting to backend OR
  // - no video OR
  // - no description
  const isButtonDisabled =
    cloudinaryUploading || submitting || !videoUrl || !description.trim();

  const buttonText = (() => {
    if (cloudinaryUploading) return 'Uploading video to Cloudinary...';
    if (submitting) return 'Posting...';
    return 'Post Video';
  })();

  return (
    <div className="max-w-2xl mx-auto my-10 p-6 bg-gray-900 rounded-2xl border border-gray-700 shadow-xl">
      <h2 className="text-2xl font-bold text-white mb-6">Post a Video</h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <CloudinaryUpload
          onUploadStart={handleUploadStart}
          onUploadComplete={handleUploadComplete}
          accept="video/*"
          maxSizeMB={150}
          label="Upload Video"
          folder="videos"
        />

        {videoUrl && (
          <div className="mt-4 p-3 bg-green-900/30 border border-green-800 rounded-lg">
            <p className="text-sm text-emerald-400 mb-2">Video ready:</p>
            <video src={videoUrl} controls className="w-full max-h-64 rounded" />
          </div>
        )}

        <div>
          <label className="block text-gray-300 mb-2 font-medium">
            Description
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Describe your video..."
            rows={4}
            className="w-full p-4 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-emerald-600 resize-none"
            maxLength={400}
          />
          <p className="text-right text-sm text-gray-500 mt-1">
            {description.length} / 400
          </p>
        </div>

        <button
          type="submit"
          disabled={isButtonDisabled}
          className={`
            w-full py-4 rounded-xl font-semibold transition-all text-lg
            ${
              isButtonDisabled
                ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
                : 'bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg shadow-emerald-900/30'
            }
          `}
        >
          {buttonText}
        </button>
      </form>

      {/* Debug helper - remove later */}
      <div className="mt-6 text-xs text-gray-500">
        Debug: videoUrl = {videoUrl ? 'set' : 'not set'} | uploading = {cloudinaryUploading ? 'yes' : 'no'}
      </div>
    </div>
  );
};

export default PostVideoForm;